import darkMap from './map-themes/dark-map.json'
import lightMap from './map-themes/light-map.json'

export { darkMap, lightMap }
